import { getNumericValue, resolveFallback } from "./formatterUtils";

type FormatNumberOptions = {
  precision?: number;
  fallback?: string;
  showFallback?: boolean;
  showZeros?: boolean;
};

export function formatNumber(value?: number | string | null, options: FormatNumberOptions = {}): string {
  const { precision = 2, fallback = "--", showFallback = true, showZeros = false } = options;

  const numericValue = getNumericValue(value);
  if (numericValue === null) {
    return resolveFallback({
      fallback,
      showFallback,
      showZeros,
      zeroValue: Number(0).toFixed(precision),
    });
  }

  return numericValue > 0 ? numericValue.toFixed(precision) : String(numericValue);
}
